import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { generateUUID } from 'src/utils/functions';
import { IStorageService } from '../../services/storageService';

class S3StorageService implements IStorageService {
  private s3Client: S3Client;

  constructor() {
    const cognitoIdentityClient = new CognitoIdentityClient({
      region: process.env.COGNITO_REGION
    });

    this.s3Client = new S3Client({
      region: process.env.REGION,
      credentials: fromCognitoIdentityPool({
        client: cognitoIdentityClient,
        identityPoolId: process.env.IDENTIFY_POOL_ID as string
      })
    });
  }

  async upload(file: File): Promise<string> {
    try {
      const id = generateUUID();
      const uploadParams = {
        Bucket: process.env.BUCKET,
        Key: `${process.env.DIR_NAME}/${id}`,
        Body: file,
        ContentType: file.type
      };

      await this.s3Client.send(new PutObjectCommand(uploadParams));

      return id;
    } catch (error) {
      throw new Error(`Error uploading file in AWS S3 bucket: ${error}`);
    }
  }
}

export default S3StorageService;
